const domainName = process.env.GATSBY_DOMAIN
const formattedDomainName = (
  domainName.charAt(0).toUpperCase() + domainName.slice(1)
).replace('shaadi', 'Shaadi')
const baseUrl = `https://www.${process.env.GATSBY_DOMAIN}`

export { domainName, formattedDomainName, baseUrl }
